




































import { MessageType, PredefinedOptionType, PredefinedPreSupportOptions, SystemEvent } from '@/common/bot/enum';
import { randomId } from '@/common/bot/lib';
import { ActionSelectedEvent, ArticleAction, BaseSystemMessage, PreSupportSelectionEvent } from '@/common/bot/types';
import CustomerSupportIcon from '@/components/icons/CustomerSupportIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

const ARTICLE_ACTION_ID = 'article-action' as const;

@Component
export default class PreSupportPromptMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  get actionItems () {
    const { type, config: { action: actionConfig } = {} } = this.message;
    const restartAction = {
      id: PredefinedOptionType.RESTART_CHAT,
      message: this.$t('chat.sys.navigation.restart_here'),
      buttonText: this.$t('chat.sys.navigation.restart_chat'),
    };

    const endAction = {
      id: PredefinedOptionType.END_CHAT,
      message: this.$t('chat.sys.navigation.end_chat_here'),
      buttonText: this.$t('global.end_chat'),
    };

    const contactSupportAction = {
      id: PredefinedOptionType.CONNECT_TO_SUPPORT,
      message: this.$t('chat.sys.msg.pre_support_prompt.iff_still_issues'),
      buttonText: this.$t('chat.sys.navigation.contact_support'),
      icon: CustomerSupportIcon,
    };

    const exploreTopicsAction = {
      id: PredefinedOptionType.BROWSE_OTHER_ARTICLES,
      message: this.$t('chat.sys.msg.pre_support_prompt.or_explore_other_topics'),
      buttonText: this.$t('chat.sys.msg.pre_support_prompt.explore_other_topics'),
    };

    const articleAction = actionConfig && {
      id: ARTICLE_ACTION_ID,
      message: actionConfig.actionMessage,
      buttonText: actionConfig.actionTitle || '',
    };

    const createBreak = () => ({
      id: randomId(),
      isBlankSpace: true,
    });

    if (type === MessageType.PRE_SUPPORT_PROMPT_ACTION_ONLY) {
      return [
        createBreak(),
        createBreak(),
        articleAction,
        restartAction,
        endAction,
      ];
    }
    if (type === MessageType.PRE_SUPPORT_PROMPT_ACTION_WITH_SUPPORT) {
      return [
        createBreak(),
        createBreak(),
        articleAction,
        createBreak(),
        contactSupportAction,
        exploreTopicsAction,
      ];
    }
    if (type === MessageType.PRE_SUPPORT_PROMPT_BARE) {
      return [
        ...(this.message.message ? [createBreak(), createBreak()] : []),
        restartAction,
        endAction,
      ];
    }
  }

  buildEvent (button: {
    id: PredefinedPreSupportOptions | typeof ARTICLE_ACTION_ID;
    message: string;
    buttonText: string;
    actionConfig: ArticleAction
  }) {
    if (button.id === ARTICLE_ACTION_ID) {
      const event: ActionSelectedEvent = {
        type: SystemEvent.ACTION_SELECTED,
        message: this.message,
        payload: { action: this.message.config?.action! },
      };
      this.$emit('send:event', event);
      return;
    }

    const event: PreSupportSelectionEvent = {
      type: SystemEvent.PRE_SUPPORT_SELECTION,
      message: this.message,
      payload: {
        selected: button.id,
      },
    };

    this.$emit('send:event', event);
  }
}
